import CommonPage  from "./Components/Pages/CommonPage/CommonPage";
import React,{useState} from "react";
import CustomKeyboardComp from "./Components/KeyboardUtils/CustomKeyboardComp";

import CustomSpinnerComp from "./Components/CommonUtils/CustomSpinnerComp";
import CustomOverlayComp from "./Components/CommonUtils/CustomOverlayComp";
import "./App.scss";
import {AppContext} from "./Context/Context";
import "./CommonUtils/Alert.scss";
import {useRecoilValue} from "recoil";
import {spinnerOverlayAtom} from "./Recoil State/Atoms/AppAtoms"


function App() {

  const [keyboardVisibility,setKeyboardVisibility]=useState(false);
  const spinnerOverlayState=useRecoilValue(spinnerOverlayAtom);

  return (
    <div className="App">
      <AppContext.Provider value={{keyboardVisibility,setKeyboardVisibility}}>
      <CustomKeyboardComp keyboardVisibility={keyboardVisibility}/>
      <CommonPage/>   
      {spinnerOverlayState.displaySpinner && <CustomSpinnerComp />}
      {spinnerOverlayState.displayOverlay && <CustomOverlayComp/>} 
      </AppContext.Provider>
    </div>
  );
}

export default App;
